import React from "react";
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { settingsSetLang } from '../../redux/actions/settings.action';
import { lng } from '../../i18n/cfg.json';
import {
  Collapse,
  Navbar,
  Nav,
  Container,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown
} from "reactstrap";

const HomeNavbar = (props) => {
  const { t } = useTranslation(['common', 'home']);
  let history = useHistory();
  const getBtn = () => {
    if (!props.beaconApply || !props.apiResponsed) {
      return;
    }
    if (!props.beacon) {
      return(
        <>
          <Button className="installAddon" color="info" onClick={()=> window.open(typeof(chrome) == "object" ? "/chrome" : "/mozilla", "_self")}>
              {t('home:getstarted.install')}
          </Button>
          <Button className="installAddon" color="info" onClick={() => history.push("/wiki")}>
              {t('home.wiki')}
          </Button>
        </>);
    }
    if (!props.logged) {
      return(
        <>
          <Button className="installAddon" color="info" onClick={()=> window.open("https://companion-rust.facepunch.com/login", "_self")}>
            {t('home.login')}
          </Button>
          <Button className="installAddon" color="info" onClick={() => history.push("/wiki")}>
              {t('home.wiki')}
          </Button>
        </>);
    }
    return (
      <>
        <Button className="installAddon" color="info" onClick={() => history.push("/dashboard")}>
          {t('home.panel')}
        </Button>
        <Button className="installAddon" color="info" onClick={() => history.push("/wiki")}>
              {t('home.wiki')}
        </Button>
      </>);
  }
  const getAvailableLang = () => {
    var temp = [...lng];
    const index = temp.findIndex(lang => lang === props.locale);
    temp.splice(index, 1);
    return temp;
  }
  return (
    <>
      <Navbar className="navbar-absolute transparent" expand="lg">
          <Container fluid>
              <Collapse navbar>
                  <Nav className="ml-auto" navbar>
                      <motion.div className="d-flex" animate={{opacity: 1}} initial={{opacity: 0}}>
                        <div className="languageSelect">
                          <UncontrolledDropdown nav className="languageDropdown">
                            <DropdownToggle
                                  caret
                                  color="default"
                                  data-toggle="dropdown"
                                  nav
                                  onClick={(e) => e.preventDefault()}
                            >
                              <img alt="flag" src={require(`assets/img/flags/flag-${props.locale}.svg`).default} height="30px" width="30px"/>

                            </DropdownToggle>
                              <DropdownMenu className="dropdown-navbar" right tag="ul" >
                                {getAvailableLang().map(i => {
                                  return(<DropdownItem key={i} className="nav-item"><img alt="flag" src={require(`assets/img/flags/flag-${i}.svg`).default} className="flagImg" onClick={() => props.settingsSetLang(i)} /></DropdownItem>)
                                })}
                              </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                        {getBtn()}
                      </motion.div>
                  </Nav>
              </Collapse>
          </Container>
      </Navbar>
    </>
  );
};

const mapStateToProps = (state) => {
  const { beacon, beaconApply, logged, apiResponsed } = state.rLink;
  const { locale } = state.settings;
  return { beacon, beaconApply, logged, apiResponsed, locale };
};
const mapDispatchToProps = {
  settingsSetLang
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeNavbar);